import ReactDOM from "react-dom/client"

import App from "./App"
import reportWebVitals from "./reportWebVitals"

import "./design/css/app.css"
import "./design/css/input.css"
import "./design/css/layout.css"

import "./design/css/auth.css"
import "./design/css/dashboard.css"
import "./design/css/stream.css"
import "./design/css/create-user.css"
import "./design/css/history.css"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(<App />)

reportWebVitals()